import riskAlertsCommitTypes from "./commit-types";
import ReducerUtilities from "../../../shared/store/reducer-utilities";
import riskAlertModel from '../../models/riskAlert';


const INITIAL_RISK_ALERTS_STATE = {
  list: [],
  isLoading: []
};

function riskAlertsReducers(state = INITIAL_RISK_ALERTS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case riskAlertsCommitTypes.PUSH_RISK_ALERTS:
      return {
        ...state,
        list: [...action.riskAlerts.map(item => riskAlertModel(item))],
      };
    case riskAlertsCommitTypes.SET_RISK_ALERTS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    default:
      return state;
  }
}

export default riskAlertsReducers;